export default __webpack_public_path__ + "static/media/quote.73eaca53.svg";